import fetch from './fetch';

import { ENV } from '../settings/env';
import {
  NAV_FOOTER_URLS,
  NAV_FOOTER_MOBILE_URLS,
  NAV_METANAV_URLS,
  NAV_MOBILE_LINKS_URLS,
  NAV_MOBILE_URLS,
  NAV_SUBNAV_URLS
} from '../settings/nav';

export function getFooter() {
  return fetch(NAV_FOOTER_URLS[ENV], {}, 'cdc')
    .then(response => response.json());
}

export function getFooterMobile() {
  return fetch(NAV_FOOTER_MOBILE_URLS[ENV], {}, 'cdc')
    .then(response => response.json());
}

export function getNavMobile() {
  return fetch(NAV_MOBILE_URLS[ENV], {}, 'pcd')
    .then(response => response.json());
}

export function getNavMobileLinks() {
  return fetch(NAV_MOBILE_LINKS_URLS[ENV], {}, 'cdc')
    .then(response => response.json());
}

export function getMetanav() {
  return fetch(NAV_METANAV_URLS[ENV], {}, 'cdc')
    .then(response => response.json());
}

export function getSubnav(universe) {
  return fetch(NAV_SUBNAV_URLS[ENV](universe), {}, 'cdc')
    .then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/services/nav.js